// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bca4a753","163":"c2e8c074","264":"43379c08","283":"c89ef2d8","293":"9051d64b","389":"dc4c97db","481":"1a008415","521":"dab52544","563":"c2e4d565","637":"b8e64f37","678":"60f8ae76","787":"60fff1db","804":"f5f0da30","826":"ead7620e","925":"2de8e39d","996":"f48f265d"}[chunkId] + ".chunk.js";
};